<div  class="main-container">
    <div class="integration-hero">
        <div class="hero-content">
            <h1 class="hero-title">
                <span class="title-pay10">Welcome to</span>
                <span class="title-integration">Pay 10 Developer Portal</span>
            </h1>
            <p class="hero-subtitle">Build, Integrate, and scale your payment solution with confidence.</p>
            <p class="hero-description">
                Explore powerful APIs, developer-friendly SDKs, and comprehensive documentation designed to help you create seamless and secure payment experiences faster.
            </p>
            <button class="btn-get-started" (click)="navigateToIntegrationGuide()">Get Started</button>
        </div>
        <div class="hero-illustration">
            <img src="assets/img/home-illustration.png" alt="Home illustration" class="illustration-img">
        </div>
    </div>
</div>
